<template>
  <p>
    Please reach out if there's an unrecognized charge from 'Giftly' on your statement.
    We will work with you to locate information about the purchase and reverse the charge,
    as needed.
  </p>

  <p>
    For other support inquiries, or to modify, resend, or cancel a gift, please visit our
    <GLink href="/support">Support Center</GLink> where you can access an array of
    self-service tools and our FAQ.
  </p>

  <div class="pb-6">
    <GDivider/>
  </div>

  <p>
    When you contact us about an unrecognized charge, please include the last 4 digits of
    the card number, the amount, and date of the transaction.
  </p>

  <p>
    <strong>Email us:</strong> <a href="mailto:billing@giftly.com">billing@giftly.com</a>
  </p>

  <p>
    <strong>Leave us a voicemail:</strong> <a href="tel:800-566-9669">800-566-9669</a>
  </p>
</template>
